export class StoredgeUnitPreview {
    public id: string;
    public storedgeId: string;
    public name: string;
    public status: number;
    public lastUpdated: string;

    public isSelected: boolean;
}
